import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginserviceService } from '../../Shared/Services/loginservice.service';
import { PLAccessToken } from '../../Shared/Model/pl-access-token';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
// import { $ } from 'protractor';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  Frmlogin: FormGroup;
  AccessTokenmodel: PLAccessToken;
  loaders: boolean = false;
  txtGeneratePassword: boolean = false;
  txtConfirmGeneratePassword: boolean = false;
  chkConfirmPas: boolean = false;
  readonly = false;
  txtOTP: boolean = false;
  btnVerifyUser: boolean = true;
  btnUpdate: boolean = false;

  btnForgorPassVerify: boolean = true;
  btnForGotPassGenerate: boolean = false;

  AuctionShowArraysLive: any = [];
  AuctionShowArraysExpire: any = [];
  AuctionTitle: string;

  DownloadAuctionList: any = [];
  DownloadFilterAuctionPending: any = [];

  AuctionCategoryList: any = [];

  dataSourceDownloadAuction = new MatTableDataSource(this.DownloadAuctionList);


  displayedColumns = ['SrNo', 'AuctionNo', 'AuctionTitle', 'AuctionStartDate', 'AuctionEndDate', 'Action', 'Location'];
  displayedColumnsLive = ['SrNo', 'AuctionNo', 'AuctionTitle', 'AuctionStartDate', 'AuctionEndDate', 'Action', 'Location'];
  dataSourceLive = new MatTableDataSource<any>(this.AuctionShowArraysLive);
  dataSourceExpired = new MatTableDataSource<any>(this.AuctionShowArraysExpire);
  displayedColumnsDownloadAuction: string[] = ['SrNo', 'DocumentName', 'Download'];////'DocumentType','Description'
  // @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  // @ViewChild(MatSort, { static: false }) sort: MatSort;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  AuctionShowArraysExpireView: any = []; AuctionShowArraysLiveView: any = [];

  constructor(private Fb: FormBuilder, private router: Router, private MsgService: ToastrService,
    private LoginServ: LoginserviceService) { // this.CreateLogin(); 
  }

  ngOnInit() {
    this.CreateLogin();
    this.GridAuctionLive();
  }
  CreateLogin() {
    this.Frmlogin = this.Fb.group({
      txtusername: ['', Validators.required],
      txtpassword: ['', Validators.required],
      customCheck: [''],
      customCheck1: [''],
      fbGeneratePassword: this.Fb.group({
        txtGenPassUserName: [''],
        txtGenPassword: [''],
        txtConfirmGenPassword: ['']
      }),
      ForgPass: this.Fb.group({
        txtForgotUserName: [''],
        txtForgotPassword: [''],
        txtConfirmForgotPassword: [''],
        txtForgotOTP: [''],
        ddlAuctionCategoryType: ['null', Validators.required]
      })

    });
  }

  OnViewLocation(AutoId: number, ActiveInd: number) {
    debugger
    if (ActiveInd == 0) {
      this.AuctionShowArraysExpireView = this.AuctionShowArraysExpire.filter(m => m.AutoId == AutoId);
    } else if (ActiveInd == 1) {
      this.AuctionShowArraysExpireView = this.AuctionShowArraysLive.filter(m => m.AutoId == AutoId);
    }

    // let latitude = '22.7137987';
    // let longitude = '75.8840006';
    let latitude = this.AuctionShowArraysExpireView[0]['Latitude'];
    let longitude = this.AuctionShowArraysExpireView[0]['Longitude'];

    let DownLLink = 'http://maps.google.com/maps?q=' + latitude + ',' + longitude;

    const link = document.createElement('a');
    link.target = '_blank';
    link.href = DownLLink;
    link.setAttribute('visibility', 'hidden');//JMCEauctionAPI\Documents\AuctionPDF
    link.click();
  }
  FillGridDownloadFirmPending() {

    let OrgCode = this.AuctionShowArraysExpireView[0]['OrgCode']
    let CityCode = this.AuctionShowArraysExpireView[0]['CityCode']
    let AuctionId = this.AuctionShowArraysExpireView[0]['AuctionId']
    this.LoginServ.DownloadDocument(AuctionId, OrgCode, CityCode).subscribe(resp => {
      if (resp) {
        if (resp.SuccessCD == 1 && resp.RespData != null) {
          this.DownloadAuctionList = resp.RespData.Table;
          this.dataSourceDownloadAuction = new MatTableDataSource<any>(this.DownloadAuctionList);
          this.dataSourceDownloadAuction.paginator = this.paginator.toArray()[5];
          this.dataSourceDownloadAuction.sort = this.sort.toArray()[5];
        }
        else {
          this.MsgService.warning(resp.MsgDesc);
        }
      } else {
        this.MsgService.error('Server Side Error...');
      }
    }, err => {
      this.MsgService.error(err);
    });

  }
  OnDownloadAuction(AutoId: any, AuctionId: any, SrNo: Number) {
    this.DownloadFilterAuctionPending = [];
    this.DownloadFilterAuctionPending = this.DownloadAuctionList.filter(m => m.AutoId == AutoId && m.AuctionId == AuctionId && m.SrNo == SrNo);

    let DownLLink = this.DownloadFilterAuctionPending[0]['VirtualPath']
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = DownLLink;
    link.setAttribute('visibility', 'hidden');//JMCEauctionAPI\Documents\AuctionPDF
    link.click();

  }
  OnLogin() {

    try {

      if (this.Frmlogin.valid) {
        this.loaders = true;
        this.LoginServ.UserLogin(this.Frmlogin.value).subscribe(respdata => {
          if (respdata != "" && respdata != null && respdata.SuccessCD == 1) {

            // ************** change 16012020 *******************************
            let ResponseEncrpt = window.btoa(JSON.stringify(respdata.RespData));
            sessionStorage.setItem('loginSession', ResponseEncrpt);
            //*********************************** End ***********************

            // console.table(respdata.RespData);

            if (respdata.RespData[0]['UserLevelId'] == 2) {
              this.router.navigate(['/admin']);
            }
            else if (respdata.RespData[0]['UserLevelId'] == 3) {
              this.router.navigate(['/DA']);
            }
            else if (respdata.RespData[0]['UserLevelId'] == 4) {
              this.router.navigate(['/LDCRO']);
            }
            else if (respdata.RespData[0]['UserLevelId'] == 5) {
              this.router.navigate(['/DC']);
            }


            //*****************For New ZOne Wise DA RO DC******** */
            else if (respdata.RespData[0]['UserLevelId'] == 6) {
              this.router.navigate(['/DA']);
            }
            else if (respdata.RespData[0]['UserLevelId'] == 7) {
              this.router.navigate(['/LDCRO']);
            }
            else if (respdata.RespData[0]['UserLevelId'] == 8) {
              this.router.navigate(['/DC']);
            }

            //*****************For New DA RO DC******** */
            else if (respdata.RespData[0]['UserLevelId'] == 10) {
              this.router.navigate(['/bidder']);
            }
            else {
              this.MsgService.warning('error');
            } this.MsgService.success(respdata.Msg);
          }
          else {
            this.MsgService.warning(respdata.Msg);
            this.loaders = false;
          }
        }, (error) => {
          this.MsgService.error(error);
          this.loaders = false;
        })
      } //this.loaders = false;
    } catch (error) {
      console.log(error);
      this.loaders = false;
    }
  }

  viewdata(AutoId: number, ActiveInd: number) {
    if (ActiveInd == 0) {
      this.AuctionShowArraysExpireView = this.AuctionShowArraysExpire.filter(m => m.AutoId == AutoId);
    } else if (ActiveInd == 1) {
      this.AuctionShowArraysExpireView = this.AuctionShowArraysLive.filter(m => m.AutoId == AutoId);
    }
    this.FillGridDownloadFirmPending();
  }

  GridAuctionLive() {
    try {
      let Ind = 1
      let OrgCode = 101;
      let CityCode = 1001001;
      this.LoginServ.GetAuctionGrid(Ind, OrgCode, CityCode).subscribe(resp => {
        if (resp) {
          if (resp.SuccessCD == 1 && resp.RespData != null) {
            // console.log(resp);

            this.AuctionShowArraysLive = resp.RespData.Table;

            this.dataSourceLive = new MatTableDataSource<any>(this.AuctionShowArraysLive);
            this.dataSourceLive.paginator = this.paginator.toArray()[0];
            this.dataSourceLive.sort = this.sort.toArray()[0];

            this.AuctionShowArraysExpire = resp.RespData.Table1;

            this.dataSourceExpired = new MatTableDataSource<any>(this.AuctionShowArraysExpire);
            this.dataSourceExpired.paginator = this.paginator.toArray()[1];
            this.dataSourceExpired.sort = this.sort.toArray()[1]

            this.AuctionCategoryList = resp.RespData.Table2;

          } else {
            this.MsgService.warning(resp.MsgDesc);
          }
        } else {
          this.MsgService.error('Server Side Error...');
        }
      }, err => {
        this.MsgService.error(err);
      });
    }
    catch (error) {
      this.MsgService.error(error);
    }
  }

  Tender(tenderid: number) {

    if (tenderid == 1) {
      document.getElementById("Live_Tender").style.display = "block";
      document.getElementById("Expired_Tender").style.display = "none";
      // this.Live_Tender = true;
      // this.Expired_Tender = false;

      document.getElementById("LiveTenderSerach").style.display = "block";
      document.getElementById("ExpiredTenderSearch").style.display = "none";

      // this.LiveTenderSerach = true;
      // this.ExpiredTenderSearch = false;
    }
    else {
      document.getElementById("Live_Tender").style.display = "none";
      document.getElementById("Expired_Tender").style.display = "block";

      // this.Live_Tender = false;
      // this.Expired_Tender = true;
      document.getElementById("LiveTenderSerach").style.display = "none";
      document.getElementById("ExpiredTenderSearch").style.display = "block";

      // this.LiveTenderSerach = false;
      // this.ExpiredTenderSearch = true;

    }
  }

  applyFilter(filterValue: string) {
    this.dataSourceLive.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceLive.paginator) {
      this.dataSourceLive.paginator.firstPage();
    }
  }
  applyFilterExpired(filterValue: string) {
    this.dataSourceExpired.filter = filterValue.trim().toLowerCase();
    if (this.dataSourceExpired.paginator) {
      this.dataSourceExpired.paginator.firstPage();
    }
  }



  //**************** Generate Password */
  OnGeneratePassword() {
    let UserNm = this.Frmlogin.controls.fbGeneratePassword.get("txtGenPassUserName").value;
    if (UserNm != "" && UserNm != null) {  // ********** Check User Name
      let Ind = 2;
      this.LoginServ.CheckUserName(Ind, UserNm).subscribe(res => {
        if (res != null) {
          if (res.SuccessCD == 1) {
            this.txtGeneratePassword = true;
            this.txtConfirmGeneratePassword = true;
            this.MsgService.success("Create Your Password...!");
            this.readonly = true;
            this.btnForgorPassVerify = false;
            this.btnForGotPassGenerate = true;
          }
          else {
            alert('You Are Not Authorized.....!!')
          }
        }
      })

    } else {

      alert('User Name Is Required...!!')
    }

  }
  OnUpdatePassword() {
    let UserNm = this.Frmlogin.controls.fbGeneratePassword.get("txtGenPassUserName").value;
    let Pass = this.Frmlogin.controls.fbGeneratePassword.get("txtGenPassword").value;
    let ConfirmPass = this.Frmlogin.controls.fbGeneratePassword.get("txtConfirmGenPassword").value;

    if (UserNm != "" && UserNm != null && Pass != "" && Pass != null && ConfirmPass != "" && ConfirmPass != null) { // ********** Update Password
      const data = {
        Ind: 3,
        UserName: UserNm,
        Password: Pass
      }
      this.LoginServ.PasswordGenerate(data).subscribe(res => {
        if (res != null) {
          if (res.SuccessCD == 1) {
            this.MsgService.success(res.Msg);
            this.OnClosed();
            $('#GeneratePassword').modal('hide');
          } else {
            this.MsgService.warning(res.Msg);
          }
          this.btnForgorPassVerify = true;
          this.btnForGotPassGenerate = false;
        }
      })

    } else {
      //alert('User Name Is Required...!!')
    }

  }

  ChkConfirmPas(event) {
    if (this.Frmlogin.controls.fbGeneratePassword.get("txtGenPassword").value != '') {
      if (this.Frmlogin.controls.fbGeneratePassword.get("txtGenPassword").value != this.Frmlogin.controls.fbGeneratePassword.get("txtConfirmGenPassword").value) {

        this.chkConfirmPas = true;
        this.Frmlogin.controls.fbGeneratePassword.get("txtConfirmGenPassword").reset('');
      }
      else {
        this.chkConfirmPas = false;
      }
    }
  }
  OnClosed() {
    this.Frmlogin.controls.fbGeneratePassword.reset('');
    this.Frmlogin.controls.ForgPass.reset('');
    this.chkConfirmPas = null;
    this.txtGeneratePassword = false;
    this.txtConfirmGeneratePassword = false;
    this.readonly = false;
    this.btnForgorPassVerify = true;
    this.btnForGotPassGenerate = false;

  }
  VerifyUserForgotPassword() {
    let Ctg = this.Frmlogin.controls.ForgPass.get("ddlAuctionCategoryType").value;
    if (Ctg != "" && Ctg != null && Ctg != "0") {
      let UserNm = this.Frmlogin.controls.ForgPass.get("txtForgotUserName").value;

      if (UserNm != "" && UserNm != null && Ctg != "0" && Ctg != null) {  // ********** Check User Name
        let Ind = 1;
        this.LoginServ.CheckForgotPasswordUserName(Ind, UserNm, Ctg).subscribe(res => {
          debugger;
          if (res != null) {
            if (res.SuccessCD == 1) {
              this.txtOTP = true;
              this.MsgService.success("OTP Sent On Your Registered Mobile No..!");
              this.Frmlogin.controls.ForgPass.get("ddlAuctionCategoryType").disable();
              this.readonly = true;
            }
            else {
              alert('You Are Not Authorized.....!!');
              this.Frmlogin.controls.ForgPass.get("ddlAuctionCategoryType").enable();
            }
          }
        })

      } else {
        alert('Mobile No. is Required...!!')
      }
    }
    else {

      alert('Please Select Auction Category Type');
      $('#ForgotPassword').modal('show');
    }


  }
  VerifyOTP() {
    let UserMobNO = this.Frmlogin.controls.ForgPass.get("txtForgotUserName").value;
    let OTP = this.Frmlogin.controls.ForgPass.get("txtForgotOTP").value;
    if (OTP == '') {
      this.MsgService.warning('Enter OTP..!');
      return;
    }
    this.LoginServ.CheckForgotOTP(UserMobNO, OTP).subscribe(result => {
      if (result.SuccessCD == 1) {
        this.txtGeneratePassword = true;
        this.txtConfirmGeneratePassword = true;
        this.btnVerifyUser = false;
        this.btnUpdate = true;
        this.MsgService.success('Mobile Number Verified!');
      } else {
        this.MsgService.warning('OTP Not matched!');
      }
    })

  }

  ChkForgotConfirmPas(event) {
    if (this.Frmlogin.controls.ForgPass.get("txtForgotPassword").value != '') {
      if (this.Frmlogin.controls.ForgPass.get("txtForgotPassword").value != this.Frmlogin.controls.ForgPass.get("txtConfirmForgotPassword").value) {

        this.chkConfirmPas = true;
        this.Frmlogin.controls.ForgPass.get("txtConfirmForgotPassword").reset('');
      }
      else {
        this.chkConfirmPas = false;
      }
    }
  }
  OnForgotUpdatePassword() {

    let UserNm = this.Frmlogin.controls.ForgPass.get("txtForgotUserName").value;
    let Pass = this.Frmlogin.controls.ForgPass.get("txtForgotPassword").value;
    let Ctg = this.Frmlogin.controls.ForgPass.get("ddlAuctionCategoryType").value;

    let ConfirmPass = this.Frmlogin.controls.ForgPass.get("txtConfirmForgotPassword").value;

    if (UserNm != "" && UserNm != null && Pass != "" && Pass != null && ConfirmPass != "" && ConfirmPass != null && Ctg != "0" && ConfirmPass != "null") { // ********** Update Password
      const data = {
        Ind: 2,
        UserName: UserNm,
        Password: Pass,
        Ctg: Ctg
      }
      this.LoginServ.ForgotPasswordUpdate(data).subscribe(res => {
        if (res != null) {
          if (res.SuccessCD == 1) {
            this.txtOTP = false;
            this.btnVerifyUser = true;
            this.btnUpdate = false;
            this.MsgService.success(res.Msg);
            this.OnClosed();
            $('#ForgotPassword').modal('hide');
            this.Frmlogin.controls.ForgPass.get("ddlAuctionCategoryType").enable();

          } else {
            this.MsgService.warning(res.Msg);
          }
        }
      })

    } else {
      //alert('User Name Is Required...!!')
    }
  }

  get chkValidForgotPassModal() {
    if (this.Frmlogin.controls.ForgPass.get('ddlAuctionCategoryType').value == '' || this.Frmlogin.controls.ForgPass.get('ddlAuctionCategoryType').value == null) {
      return true;
    }
    if (this.Frmlogin.controls.ForgPass.get('txtForgotUserName').value == '' || this.Frmlogin.controls.ForgPass.get('txtForgotUserName').value == null) {
      return true;
    }
    return false;
  }

}